import React from 'react'

import background from './../UI/Intro.webp'

import {getProyecto, getDropboxFiles} from './../services/renders.dao'
import { ContextLoader } from "./../utils/import.frames";

import LoadingScreen from './ingreso/loadingScreen.component';
import WelcomeScreen from './ingreso/welcomeScreen.component';
import Canvas from './canvas.component';

interface Ingreso{
    general: Array<String>
    torre1: Array<String>
    torre2: Array<String>
    images: Array<String>
    porteria: Array<String>
    torre3: Array<String>
    torre4: Array<String>
    torre5: Array<String>
    torre6: Array<String>
    torre7: Array<String>
    torre8: Array<String>
    torre9: Array<String>
    torre10: Array<String>
    crossfit: Array<String>
    fisica: Array<String>
    yoga: Array<String>
    lectura: Array<String>
    estadia: Array<String>
    masajes: Array<String>
    ping: Array<String>
    bbq: Array<String>
    piscina: Array<String>
    parque: Array<String>
    habilidades: Array<String>
    guarderia: Array<String>
    pet: Array<String>
}

interface Props{}

interface State{
    isLoading: boolean,
    proyecto: any,
    textures: any,
    gettingProjectInfo: boolean,
    errorGettingProjectInfo: boolean,
    downloadingImagesInfo: boolean,
    errorDowloadingImages: boolean,
    loadedImages: number,
    isWelcome: boolean,
    dissapearWelcome: boolean
}

class Ingreso extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {
            isLoading: true,
            proyecto: {},
            textures: {},
            gettingProjectInfo: true,
            errorGettingProjectInfo: false,
            downloadingImagesInfo: false,
            errorDowloadingImages: false,
            loadedImages: 0,
            isWelcome: false,
            dissapearWelcome: true
        }
    }

    async componentDidMount(){
        try {
            this.setState({
                proyecto: await getProyecto()
            }, async () => {
                try{
                    const texts =  await getDropboxFiles()
                    var result = texts.data.files
                    var dicc: any = {}


                    result.forEach((element: any) => {
                        dicc[element.path] = element.link
                    });
                    this.setState({
                        textures: dicc
                    }, () => {
                        this.setState({
                            gettingProjectInfo: false
                        }, () => {
                            this.setState({
                                downloadingImagesInfo: true
                            })
                            this.general = ContextLoader["General View"]()
                            this.torre1 = ContextLoader["Torre 1"]()
                            this.torre2 = ContextLoader["Torre 2"]()
                            this.torre3 = ContextLoader["Torre 3"]()
                            this.torre4 = ContextLoader["Torre 4"]()
                            this.torre5 = ContextLoader["Torre 5"]()
                            this.torre6 = ContextLoader["Torre 6"]()
                            this.torre7 = ContextLoader["Torre 7"]()
                            this.torre8 = ContextLoader["Torre 8"]()
                            this.torre9 = ContextLoader["Torre 9"]()
                            this.torre10 = ContextLoader["Torre 10"]()

                            this.images = [
                                this.general[0],
                                this.general[6],
                                this.general[12],
                                this.general[18],
                                this.general[24],
                                this.general[30],
                                this.general[36],
                                this.general[42],
                                this.general[48],
                                this.general[54],
                                this.general[60],
                                this.general[66],

                                this.torre1[0],
                                this.torre1[6],
                                this.torre1[12],
                                this.torre1[18],
                                this.torre1[24],
                                this.torre1[30],
                                this.torre1[36],
                                this.torre1[42],
                                this.torre1[48],
                                this.torre1[54],
                                this.torre1[60],
                                this.torre1[66],

                                this.torre2[0],
                                this.torre2[6],
                                this.torre2[12],
                                this.torre2[18],
                                this.torre2[24],
                                this.torre2[30],
                                this.torre2[36],
                                this.torre2[42],
                                this.torre2[48],
                                this.torre2[54],
                                this.torre2[60],
                                this.torre2[66],

                                this.torre3[0],
                                this.torre3[6],
                                this.torre3[12],
                                this.torre3[18],
                                this.torre3[24],
                                this.torre3[30],
                                this.torre3[36],
                                this.torre3[42],
                                this.torre3[48],
                                this.torre3[54],
                                this.torre3[60],
                                this.torre3[66],

                                this.torre4[0],
                                this.torre4[6],
                                this.torre4[12],
                                this.torre4[18],
                                this.torre4[24],
                                this.torre4[30],
                                this.torre4[36],
                                this.torre4[42],
                                this.torre4[48],
                                this.torre4[54],
                                this.torre4[60],
                                this.torre4[66],

                                this.torre5[0],
                                this.torre5[6],
                                this.torre5[12],
                                this.torre5[18],
                                this.torre5[24],
                                this.torre5[30],
                                this.torre5[36],
                                this.torre5[42],
                                this.torre5[48],
                                this.torre5[54],
                                this.torre5[60],
                                this.torre5[66],

                                this.torre6[0],
                                this.torre6[6],
                                this.torre6[12],
                                this.torre6[18],
                                this.torre6[24],
                                this.torre6[30],
                                this.torre6[36],
                                this.torre6[42],
                                this.torre6[48],
                                this.torre6[54],
                                this.torre6[60],
                                this.torre6[66],
 
                                this.torre7[0],
                                this.torre7[6],
                                this.torre7[12],
                                this.torre7[18],
                                this.torre7[24],
                                this.torre7[30],
                                this.torre7[36],
                                this.torre7[42],
                                this.torre7[48],
                                this.torre7[54],
                                this.torre7[60],
                                this.torre7[66],
                                
                                this.torre8[0],
                                this.torre8[6],
                                this.torre8[12],
                                this.torre8[18],
                                this.torre8[24],
                                this.torre8[30],
                                this.torre8[36],
                                this.torre8[42],
                                this.torre8[48],
                                this.torre8[54],
                                this.torre8[60],
                                this.torre8[66],

                                this.torre9[0],
                                this.torre9[6],
                                this.torre9[12],
                                this.torre9[18],
                                this.torre9[24],
                                this.torre9[30],
                                this.torre9[36],
                                this.torre9[42],
                                this.torre9[48],
                                this.torre9[54],
                                this.torre9[60],
                                this.torre9[66],

                                this.torre10[0],
                                this.torre10[6],
                                this.torre10[12],
                                this.torre10[18],
                                this.torre10[24],
                                this.torre10[30],
                                this.torre10[36],
                                this.torre10[42],
                                this.torre10[48],
                                this.torre10[54],
                                this.torre10[60],
                                this.torre10[66],
                            ]

                            this.images.forEach((src: any) => {
                                new Promise((resolve, reject) => {
                                    const img = new Image();
                                    img.src = src

                                    img.onload = (event) => {
                                        this.setState({
                                            loadedImages: this.state.loadedImages + 1 
                                        }, () => {
                                            if(this.state.loadedImages === this.images.length){
                                                this.setState({
                                                    downloadingImagesInfo: false,
                                                    isLoading: false
                                                })
                                            }
                                        })
                                    }
                                    img.onerror = (err) => {
                                        reject()
                                    }
                                }).catch((e) => {
                                    this.setState({
                                        errorDowloadingImages: true
                                    })
                                })
                            })
                        })
                    })
                }
                catch(err){
                    this.setState({
                        errorGettingProjectInfo: true
                    })
                }
            })
        }
        catch(err){
            this.setState({
                errorGettingProjectInfo: true
            })
        }
    }

    handleHideWelcomeScreen = () => {
        this.setState({
            isWelcome: true
        })
        setTimeout(function(this: any){
            this.setState({
                dissapearWelcome: false
            })
        }.bind(this), 700)
    }

    render(): React.ReactNode {
        return(
            <div className='ingreso-page'>
                <img src={background} className='background-image'/>
                <LoadingScreen 
                    isLoading = {this.state.isLoading}
                    gettingProjectInfo={this.state.gettingProjectInfo}
                    errorGettingProjectInfo={this.state.errorGettingProjectInfo}
                    downloadingImagesInfo={this.state.downloadingImagesInfo}
                    errorDownloadingImages={this.state.errorDowloadingImages}
                />
                {this.state.isLoading === false  ?
                    <Canvas 
                        isWelcome = {this.state.isWelcome}
                        proyecto = {this.state.proyecto.data}
                        textures = {this.state.textures}
                        loadedImages={this.state.loadedImages}
                    /> : null
                }
                {this.state.dissapearWelcome ?
                    <WelcomeScreen 
                        isLoading = {this.state.isLoading}
                        isWelcome = {this.state.isWelcome}
                        handleHideWelcome={this.handleHideWelcomeScreen}
                    />: null
                }
            </div>
        )
    }
}

export default Ingreso